var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:`btn-${_vm.type} ${_vm.classes}`,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }